import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Cluster = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Cluster' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M8,9 L16,9 L16,1 L8,1 L8,9 Z M1,23 L9,23 L9,15 L1,15 L1,23 Z M15,23 L23,23 L23,15 L15,15 L15,23 Z M5,15 L8,9 L5,15 Z M10,19 L14,19 L10,19 Z M16,9 L19,15 L16,9 Z' />
  </StyledIcon>
);
